// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const pickDataAttributes = (props) => {
    const dataAttributes = {};
    Object.keys(props).forEach(key => {
        if (key.startsWith('data-')) {
            dataAttributes[key] = props[key];
        }
    });
    return dataAttributes;
};
//# sourceMappingURL=pickDataAttributes.js.map